import fields from './fields';
import label from './label';
import desktopLabel from './desktopLabel';
import mobileLabel from './mobileLabel';
import content from './content';

const styles = (theme) => ({
  content: content(theme),
  desktopLabel: desktopLabel(theme),
  fields: fields(theme),
  label: label(theme),
  mobileLabel: mobileLabel(theme),
});

export default styles;
